module.exports = __webpack_public_path__ + "img/sec1_box8.e0ca4a99.jpg";